import { ActionTypes } from "./actionTypes";
import { IPayloadAction, createAction, createPayloadAction } from "./actionCreators";
import { Dispatch } from "redux";
import { IAuthenticationState } from "../../models/applicationState";
import LoginService from "../../services/loginService";

export default interface IAuthenticationActions {
    getLoggedInUser(requestBody: any): Promise<void>;
    changeUserPassword(requestBody: any): Promise<void>;
    userLoggedOut(): Promise<void>;
}

export function getLoggedInUser(requestBody: any):
 (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        const loginService = new LoginService();
        const data = await loginService.login(requestBody);
        dispatch(loggedInUser(data));
        return data;
    };
}

export function userLoggedOut(): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        localStorage.clear();
        dispatch(loggedOutUser(true));
    };
}

export function changeUserPassword(requestBody: any):
 (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        const loginService = new LoginService();
        const data = await loginService.changePassword(requestBody);
        return data;
    };
}
export interface IAuthAction extends IPayloadAction<string, any> {
    type: ActionTypes.LOGGED_IN_USER;
}
export interface ILogoutAction extends IPayloadAction<string, boolean> {
    type: ActionTypes.LOGGED_OUT_USER;
}

export const loggedInUser = createPayloadAction<IAuthAction>(ActionTypes.LOGGED_IN_USER);
export const loggedOutUser = createPayloadAction<ILogoutAction>(ActionTypes.LOGGED_OUT_USER);
